import React, { ReactNode } from 'react';
import './MainLayout.scss';
import { IStyle } from '../components/roots/IRoots';
import { FlexBox, TextCommon } from '../../components';

interface AgencyPageLayoutProps<T> extends IStyle {
    extraData?: T;
    pageTitle?: string;
    RightExtraContent?: ReactNode;
    children: ReactNode;
}

export const AgencyPageLayout = <T,>({
    pageTitle,
    RightExtraContent,
    children
}: AgencyPageLayoutProps<T>) => {
    return (
        <FlexBox direction='column' gap={12} >
            <FlexBox gap={12} flex={'none'}>
                <FlexBox>
                    {!!pageTitle && <TextCommon fontWeight={600}>{pageTitle}</TextCommon>}
                </FlexBox>
                {RightExtraContent && RightExtraContent}
            </FlexBox>

            <FlexBox direction='column'>
                {children}
            </FlexBox>
        </FlexBox>
    );
};
